import { render, staticRenderFns } from "./EmblaCarousel.vue?vue&type=template&id=1d43edd6&scoped=true"
import script from "./EmblaCarousel.vue?vue&type=script&lang=js"
export * from "./EmblaCarousel.vue?vue&type=script&lang=js"
import style0 from "./EmblaCarousel.vue?vue&type=style&index=0&id=1d43edd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43edd6",
  null
  
)

export default component.exports